export class ieAlert extends DrupalBehavior {
  build() {
    const drawer = document.querySelector('.drawer');
    const alert = document.createElement('div');
    alert.setAttribute('class', 'ie-alert');
    drawer.appendChild(alert);

    const alertWrap = document.querySelector('.ie-alert');
    const inner = document.createElement('div');
    inner.setAttribute('class', 'ie-alert__inner');
    alertWrap.appendChild(inner);

    const innerWrap = document.querySelector('.ie-alert__inner');

    const close = document.createElement('button');
    close.setAttribute('class', 'ie-alert__close');
    close.setAttribute('aria-label', 'Close Internet Explorer Alert');
    close.innerHTML +=
      '<svg width="18px" height="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><defs><style>.cls-1{fill:#353535;fill-rule:evenodd;}</style></defs><path class="cls-1" d="M1.8,0,9,7.2,16.2,0,18,1.8,10.8,9,18,16.2,16.2,18,9,10.8,1.8,18,0,16.2,7.2,9,0,1.8Z"/></svg>';
    innerWrap.appendChild(close);

    const heading = document.createElement('h2');
    heading.setAttribute('class', 'ie-alert__heading');
    heading.innerHTML += 'This site is not optimized for Internet Explorer.';
    innerWrap.appendChild(heading);

    const body = document.createElement('div');
    body.setAttribute('class', 'ie-alert__body');
    body.innerHTML +=
      '<p>We see that you are using Internet Explorer. For a better experience, we recommend using a different browser such as <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>, <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a>, or <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a>.</p>';
    innerWrap.appendChild(body);

    const icons = document.createElement('div');
    icons.setAttribute('class', 'ie-alert__icons');
    icons.innerHTML +=
      '<div class="ie-alert__chrome"><img src="/themes/rush_theme/public/images/chrome.png" alt="Chrome logo"></div><div class="ie-alert__firefox"><img src="/themes/rush_theme/public/images/firefox.png" alt="Firefox logo"></div><div class="ie-alert__safari"><img src="/themes/rush_theme/public/images/safari.png" alt="Safari logo"></div>';
    innerWrap.appendChild(icons);
  }

  readStorage() {
    alert = document.querySelector('.ie-alert');

    if (sessionStorage.getItem('ieAlert') == 'true') {
      alert.style.display = 'none';
    }
  }

  close() {
    alert = document.querySelector('.ie-alert');

    if (alert) {
      const acceptButton = alert.querySelector('button.ie-alert__close');
      acceptButton.addEventListener('click', function () {
        sessionStorage.setItem('ieAlert', 'true');
        alert.style.display = 'none';
      });

      this.readStorage();
    }
  }

  ieAlert() {
    if (document.documentMode) {
      this.build();
      this.close();
    }
  }

  onReady(document) {
    this.ieAlert(document);
  }
}
DrupalBehavior.register('rush_theme.components', 'ie_alert', ieAlert);
